import React from 'react';
import ReactDOM from 'react-dom';
import loadScripts from 'snapshotify';
import firebase from 'firebase/compat/app';
import './index.css';
// import * as serviceWorker from './serviceWorker';
import AppWrapper from 'AppRoot';
// import {debugContextDevtool} from 'react-context-devtool';

const container = document.getElementById('root');

// // Initialize Firebase with the right deployement
// firebase.initializeApp(firebaseConfig['dev']);

const envConfigPath = '/config.json';
const firebaseConfigPath = `/firebase-config.json`;
Promise.all([fetch(envConfigPath), fetch(firebaseConfigPath)]).then(
    async results => {
        const [appConfigResponse, firebaseConfigResponse] = results;
        const appConfig = await appConfigResponse.json();
        try {
            firebase.initializeApp(await firebaseConfigResponse.json());
        } catch (err) {
            console.warn('App Already Initialized');
        }
        if (container.hasChildNodes()) {
            loadScripts().then(() => {
                // Is this a hack? Yes.
                // Is it dirty? /shrug. Could be dirtier.
                // Remove all previous jss nodes from static render
                // React will re-load them and sometimes they don't play nice together
                document.querySelectorAll('style[data-jss]').forEach(oldStyle => {
                    oldStyle.parentElement.removeChild(oldStyle);
                });
                ReactDOM.hydrate(<AppWrapper appConfig={appConfig} />, container);
            });
        } else {
            ReactDOM.render(<AppWrapper appConfig={appConfig} />, container);
        }
    }
);

// debugContextDevtool(container, {
//     disable: process.env.NODE_ENV === 'production',
//     disableAutoMode: false,
// });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
